import { getRequest, getPublic } from "../routes/Routes";
import { toast } from "react-toastify";

export const loadWishes = async (token) => {
    let wishes = [];
    await getRequest("/api/wish", token).then((response) => {
        if (response.status === 200) {
            wishes = response.data.wishes;
        } else {
            toast.error(response.data.message, {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    });
    return wishes;
};

export const loadWish = async (wishId, token) => {
    let wish = null;
    await getRequest("/api/wish/" + wishId, token).then((response) => {
        if (response.status === 200) {
            wish = response.data.wish;
        } else {
            toast.error(response.data.message, {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    });
    return wish;
};

export const loadTemplates = async (token) => {
    let templates = [];
    await getRequest("/api/wish-template", token).then((response) => {
        if (response.status === 200) {
            templates = response.data.wishtemplates;
        } else {
            toast.error(response.data.message, {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    });
    return templates;
};

export const loadTemplate = async (wishTemplateId, token) => {
    let template = null;
    await getRequest("/api/wish-template/" + wishTemplateId, token).then(
        (response) => {
            if (response.status === 200) {
                template = response.data.wishtemplate;
            } else {
                toast.error(response.data.message, {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    );
    return template;
};

export const loadTemplateTexts = async (token) => {
    let templateTexts = [];
    await getRequest("/api/wish-template-text", token).then((response) => {
        if (response.status === 200) {
            templateTexts = response.data.wishTemplateTexts;
        } else {
            toast.error(response.data.message, {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    });
    return templateTexts;
};

export const loadTemplateText = async (wishTemplateTextId, token) => {
    let templateText = null;
    await getRequest("/api/wish-template-text/" + wishTemplateTextId, token).then(
        (response) => {
            if (response.status === 200) {
                templateText = response.data.wishTemplateText;
            } else {
                toast.error(response.data.message, {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    );
    return templateText;
};

export const loadWishTexts = async (token) => {
    let wishTexts = [];
    await getRequest("/api/wish-text", token).then((response) => {
        if (response.status === 200) {
            wishTexts = response.data.wishTexts;
        } else {
            toast.error(response.data.message, {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    });
    return wishTexts;
};

export const loadWishText = async (wishTextId, token) => {
    let wishText = null;
    await getRequest("/api/wish-text/" + wishTextId, token).then(
        (response) => {
            if (response.status === 200) {
                wishText = response.data.wishText;
            } else {
                toast.error(response.data.message, {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    );
    return wishText;
};

export const loadTestimonials = async (token) => {
    let testimonials = [];
    await getRequest("/api/testimonial", token).then((response) => {
        if (response.status === 200) {
            testimonials = response.data.testimonials;
        } else {
            toast.error(response.data.message, {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    });
    return testimonials;
};

export const loadTestimonial = async (testimonialId, token) => {
    let testimonial = null;
    await getRequest("/api/testimonial/" + testimonialId, token).then(
        (response) => {
            if (response.status === 200) {
                testimonial = response.data.testimonial;
            } else {
                toast.error(response.data.message, {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    );
    return testimonial;
};

export const loadMenus = async (token) => {
    let menus = [];
    await getRequest("/api/menu", token).then((response) => {
        if (response.status === 200) {
            menus = response.data.menus;
        } else {
            toast.error(response.data.message, {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    });
    return menus;
};

export const loadMenu = async (menuId, token) => {
    let menu = null;
    await getRequest("/api/menu/" + menuId, token).then(
        (response) => {
            if (response.status === 200) {
                menu = response.data.menu;
            } else {
                toast.error(response.data.message, {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    );
    return menu;
};

export const loadMenusPublic = async () => {
    const { data, status } = await getPublic("/api/menu/public");
    if (status === 200 && data?.menus) return data.menus;
    toast.error(data?.message || "Failed to load menus");
    return [];
};

export const loadTestimonialsPublic = async () => {
    const { data, status } = await getPublic("/api/testimonial/public");
    if (status === 200 && data?.testimonials) return data.testimonials;
    toast.error(data?.message || "Failed to load testimonials");
    return [];
};

export const loadWishByToken = async (qrToken, token) => {
    let wish = null;
    try {
        const response = await getRequest(`/api/wish/showByToken/${qrToken}`, token);
        if (response.status === 200 && !response.data?.error) {
            wish = response.data.wish || response.data;
        } else {
            toast.error(response.data?.message || "Wish not found or expired", {
                position: "bottom-center",
            });
        }
    } catch {
        toast.error("Network error while loading wish by token", {
            position: "bottom-center",
        });
    }
    return wish;
};